import { render, staticRenderFns } from "./batches.vue?vue&type=template&id=73116626&"
import script from "./batches.vue?vue&type=script&lang=js&"
export * from "./batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports